import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import sha256 from 'crypto-js/sha256';

const API_CONFIG = {
  baseURL: process.env.REACT_APP_BACKEND_URL,
  ImageUrl: process.env.REACT_APP_IMAGES_URL,
  getUserToken: () => Cookies.get('UserSpecialToken')
};

const request = async (endpoint, options = {}) => {
  const token = API_CONFIG.getUserToken();
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
    'Accept': 'application/json'
  };

  try {
    const response = await fetch(`${API_CONFIG.baseURL}${endpoint}`, {
      ...options,
      headers: headers,
      body: options.body
    });

    const data = await response.json();

    if (!response.ok) {
      if (response.status === 422 && data.errors) {
        const validationErrors = Object.values(data.errors).flat();
        throw new Error(validationErrors.join(', ') || 'Validation failed.');
      }
      throw new Error(data.message || 'API request failed');
    }
    return data;
  } catch (error) {
    throw error;
  }
};

const UtmValueForm = ({ value, typeToCreate, onSuccess, onCancel, LanguageSelected, t }) => {
  const [formData, setFormData] = useState({
    name: value?.name || '',
    type: value?.type || typeToCreate || 'source',
    is_active: value?.is_active
  });
  const [InputsErrors, setInputsErrors] = useState({});
  const [isFetching, setIsFetching] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setInputsErrors({});
    setIsFetching(true);

    try {
      if (value) {
        await request(`/utm-values/${value.id}`, {
          method: 'PUT',
          body: JSON.stringify(formData)
        });
      } else {
        await request('/utm-values', {
          method: 'POST',
          body: JSON.stringify(formData)
        });
      }
      toast.success(t(`UTM value ${value ? 'updated' : 'created'} successfully`), {
        position: toast.POSITION.CENTER
      });
      onSuccess();
    } catch (error) {
      setInputsErrors({ submit: error.message });
      toast.error(error.message, {
        position: toast.POSITION.CENTER
      });
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <div className='grid place-items-center w-full py-4 gap-4 px-4'>
      <div className="w-full">
        {/* <select
          value={formData.type}
          onChange={(e) => setFormData({ ...formData, type: e.target.value })}
          className="appearance-none block placeholder-sm w-full px-3 py-2 bg-gray-700 border-2 border-gold rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm"
          required
          disabled={!!value || !!typeToCreate}
        >
          <option value="source">{t('utm_source')}</option>
          <option value="medium">{t('utm_medium')}</option>
          <option value="campaign">{t('utm_campaign')}</option>
          <option value="term">{t('utm_term')}</option>
          <option value="content">{t('utm_content')}</option>
        </select> */}
        <p className="mt-2 text-red-600 dark:text-red-500">
          <span className="font-xsmall">{InputsErrors.hasOwnProperty('type') && InputsErrors.type}</span>
        </p>
      </div>

      <div className="w-full">
        <input
          type="text"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          placeholder={t("name")}
          className="appearance-none block placeholder-sm w-full px-3 py-2 bg-gray-700 border-none  rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm"
          style={{ backgroundColor: formData.is_active ? '#fff' : '#c43b3bff', color: formData.is_active ? '#000' : '#fff' }}

          required
        />

        <div className="w-full flex items-center gap-2 mt-2">
          <span>{t("Status")}:</span>
          <button
            type="button"
            onClick={() =>
              setFormData((prev) => ({ ...prev, is_active: !prev.is_active }))
            }
            className={`px-3 py-1 rounded font-medium ${formData.is_active ? "bg-green-500 text-white" : "bg-red-500 text-white"
              }`}
          >
            {formData.is_active ? "Active" : "Inactive"}
          </button>
        </div>


        <p className="mt-2 text-red-600 dark:text-red-500">
          <span className="font-xsmall">{InputsErrors.hasOwnProperty('name') && InputsErrors.name}</span>
        </p>
      </div>

      <button
        onClick={handleSubmit}
        disabled={isFetching}
        type="submit"
        className="w-full btn-edit"
      >
        {isFetching ? (
          <svg className="w-4 h-4 text-gray-300 animate-spin" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
            <path
              d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
              stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"
            />
            <path
              d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
              stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" className="text-gray-900"
            />
          </svg>
        ) : (
          value ? t('Update') : t('Create')
        )}
      </button>
    </div>
  );
};

const UtmTypeGroupCard = ({ type, values, onEdit, onDelete, onAdd, LanguageSelected, t }) => {
  const typeIcons = {
    source: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
      </svg>
    ),
    medium: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M7 2v11h3v9l7-12h-4l4-8z" />
      </svg>
    ),
    campaign: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    ),
    term: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
      </svg>
    ),
    content: (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
      </svg>
    )
  };

  return (
    <div className="sections rounded-lg border-2  overflow-hidden">

      <div className="bg-gray-700 p-4 border-b border-gray">
        <div className="flex items-center justify-between">
          <div className="flex items-center">

            <h3 className="text-lg font-bold text-gold capitalize">
              {t(`utm_${type}`)} ({values.length})
            </h3>
          </div>
        </div>
      </div>

      <div className="p-4 max-h-[250px] overflow-y-auto">
        {values.length === 0 ? (
          <p className="text-gray-400 italic text-center py-4">{t('No values defined yet')}</p>
        ) : (
          <div className="space-y-2">
            {values.map(value => (
              <div
                key={value.id}
                className="flex items-center justify-between p-2 rounded bg-gray-700 hover:bg-gray-600 transition-colors"
                style={{ backgroundColor: value.is_active ? '#eeeeee' : '#c43b3bff', color: value.is_active ? '#000' : '#fff' }}

              >
                <span className="text-theme truncate flex-1"
                  style={{ color: value.is_active ? '#000' : '#fff' }}

                >{value.name}</span>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => onEdit(value)}
                    className="text-gold hover:text-theme transition-colors"
                    title={t('Edit')}

                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ color: value.is_active ? '#000' : '#fff' }}>
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                  </button>
                  <button
                    onClick={() => onDelete(value.id, value.name)}
                    className="text-red-500 hover:text-red-400 transition-colors"
                    title={t('Delete')}
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ color: value.is_active ? '#000' : '#fff' }}>
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Footer: Add Button */}
      <div className="p-3 border-t border-gray">
        <button
          onClick={() => onAdd(type)}
          className="w-full font-semibold relative text-theme flex justify-center items-center p-2 border border-transparent rounded shadow-sm text-sm font-medium text-black sections hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold"
        >
          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          {t('Add')}
        </button>
      </div>
    </div>
  );
};

const UtmManager = ({ onValuesUpdate }) => {
  const { t } = useTranslation();
  const utmTypes = ['source', 'medium', 'campaign', 'term', 'content'];

  let userId = Cookies.get('userId');
  let UserToken = Cookies.get('UserSpecialToken');
  let IdEntreprise = Cookies.get('IdEntreprise');
  let LanguageSelected = Cookies.get('LanguageSelected');

  const hashedUserId = sha256((String(userId)));

  const [utmValues, setUtmValues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showManagerModal, setShowManagerModal] = useState(false);
  const [editingValue, setEditingValue] = useState(null);
  const [typeToCreate, setTypeToCreate] = useState(null);

  useEffect(() => {
    if (showManagerModal) {
      fetchUtmValues();
    }
  }, [showManagerModal]);

  const fetchUtmValues = async () => {
    setLoading(true);
    try {
      const data = await request('/utm-values');
      const valuesArray = data.data || [];
      setUtmValues(valuesArray);
      if (onValuesUpdate) {
        const grouped = valuesArray.reduce((acc, value) => {
          acc[value.type] = acc[value.type] || [];
          acc[value.type].push(value);
          return acc;
        }, {});
        onValuesUpdate(grouped);
      }

    } catch (error) {
      toast.error(t('Failed to load UTM values'), {
        position: toast.POSITION.CENTER
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(t('Are you sure you want to delete') + ` "${name}"?`)) return;

    try {
      await request(`/utm-values/${id}`, { method: 'DELETE' });
      toast.success(t('UTM value deleted successfully'), {
        position: toast.POSITION.CENTER
      });
      fetchUtmValues();
    } catch (error) {
      toast.error(t('Deletion failed'), {
        position: toast.POSITION.CENTER
      });
    }
  };

  const handleEdit = (value) => {
    setEditingValue(value);
    setTypeToCreate(null);
    setIsModalOpen(true);
  };

  const handleAddNew = (type) => {
    setEditingValue(null);
    setTypeToCreate(type);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingValue(null);
    setTypeToCreate(null);
  };

  const handleSuccess = () => {
    handleCloseModal();
    fetchUtmValues();
  };

  const filteredValues = utmValues.filter(value =>
    value.name?.toLowerCase().includes(search.toLowerCase())
  );

  const groupedValues = filteredValues.reduce((acc, value) => {
    acc[value.type] = acc[value.type] || [];
    acc[value.type].push(value);
    return acc;
  }, {});

  const finalGroupedValues = utmTypes.reduce((acc, type) => {
    acc[type] = groupedValues[type] || [];
    return acc;
  }, {});

  return (
    <div>
      <button
        onClick={() => setShowManagerModal(true)}
        type="submit"
        className="w-full font-semibold relative text-theme flex justify-start items-center mt-3 p-3 py-2 px-4 border border-transparent rounded shadow-sm text-sm font-medium text-black sections h-16 hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${LanguageSelected == 'ar' ? 'w-6 ml-3' : 'w-6 mr-3'}`}
        >
          <path
            d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
            fill="currentColor"
          />
        </svg>
        {t("utm_values_manager")}
      </button>

      {/* Main Manager Modal */}
      {showManagerModal && (
        <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
          <div className="relative w-full max-w-6xl max-h-screen overflow-auto findservice rounded-xl div-sections">
            <div className="absolute -top-2 -right-2 p-4">
              <a className='w-8 h-8' onClick={() => setShowManagerModal(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>

            <div className="w-full p-6">
              <div className={`${LanguageSelected == 'ar' ? 'pl-6' : 'pr-6'}`}>
                <div className="flex items-center justify-start mb-6">
                  <p className="text-3xl text-theme mb-2">{t("utm_values_manager")}</p>
                </div>
              </div>

              {/* Search Bar */}
              <div className="mb-6 px-4">
                <div className="flex items-center gap-4">
                  <div className="flex-1 relative">
                    <svg className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                    <input
                      type="text"
                      placeholder={t('Search')}
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      className="pl-10 pr-4 py-2 appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active  sm:text-sm"
                    />
                  </div>
                  <button
                    onClick={fetchUtmValues}
                    disabled={loading}
                    className="btn-edit px-4 py-2"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                  </button>
                </div>
              </div>

              {/* Content */}
              {loading ? (
                <div className="text-center py-8">
                  <svg className="w-8 h-8 text-gray-300 animate-spin mx-auto" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                      stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"
                    />
                    <path
                      d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                      stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" className="text-gray-900"
                    />
                  </svg>
                </div>
              ) : (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 px-4">
                    {utmTypes.map(type => (
                      <UtmTypeGroupCard
                        key={type}
                        type={type}
                        values={finalGroupedValues[type]}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        onAdd={handleAddNew}
                        LanguageSelected={LanguageSelected}
                        t={t}
                      />
                    ))}
                  </div>

                  {utmValues.length > 0 && filteredValues.length === 0 && (
                    <div className="text-center py-8 border-2 border-dashed border-grayrounded-lg mt-6 mx-4">
                      <p className="text-gray-400 text-lg">{t('No results found for')} "{search}"</p>
                      <button
                        onClick={() => setSearch('')}
                        className="mt-4 btn-edit px-4 py-2 text-sm"
                      >
                        {t('Clear Search')}
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Form Modal */}
      {isModalOpen && (
        <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
          <div className="relative w-full max-h-screen findservice overflow-hidden -mt-10 rounded-xl div-sections">
            <div className="absolute -top-2 -right-2 p-4">
              <a className='w-8 h-8' onClick={handleCloseModal}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full ">
              <div className={`${LanguageSelected == 'ar' ? 'pl-6' : 'pr-6'}`}>
                <div className="flex items-center justify-start">
                  <p className="text-3xl text-theme m-2">
                    {editingValue
                      ? `${t('Edit')} ${t(`utm_${editingValue.type}`)} ${t('Value')}`
                      : typeToCreate
                        ? `${t('Add New')} ${t(`utm_${typeToCreate}`)} ${t('Value')}`
                        : t('Create New UTM Value')
                    }
                  </p>

                </div>
              </div>
              <UtmValueForm
                value={editingValue}
                typeToCreate={typeToCreate}
                onSuccess={handleSuccess}
                onCancel={handleCloseModal}
                LanguageSelected={LanguageSelected}
                t={t}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UtmManager;